"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImportStages = exports.ImportStatus = void 0;

var _keyMirror = _interopRequireDefault(require("react-utils/keyMirror"));

var ImportStatus = (0, _keyMirror.default)({
  NONE: null,
  HAS_IMPORT: null,
  IN_PROGRESS: null,
  COMPLETE: null
});
exports.ImportStatus = ImportStatus;
var ImportStages = (0, _keyMirror.default)({
  INITIALIZING: null,
  RECEIVING: null,
  PROCESSING: null,
  FINAL_PROCESSING: null,
  COMPLETE: null,
  FAILED: null
});
exports.ImportStages = ImportStages;